/* eslint-disable */

import axios from 'axios'

const clearState = (context) => {
  context.commit('clearCountsState');
}

const obtainRewardCounts = async (context) => {
  await context.dispatch('inspectToken');

  if (context.getters.isLoggedIn) {
    const payload = {
      headers: {
        Authorization: `JWT ${context.rootState.jwt.jwt}`
      },
      params: {
        time_period: context.rootState.time_period,
        merchant_id: context.rootState.advertiser.advertiser.id,
      }
    }

    axios.get(context.state.endpoints.rewardCounts, payload)
      .then((response)=>{
        const parse_payload = {
          data: response.data,
          time_period: payload.params.time_period
        }
        context.dispatch('parseRewardCounts', parse_payload);
      })
      .catch((error)=>{
        console.log(error);
      })
  }
}

const parseRewardCounts = (context, parse_payload) => {
  for (var i = 0; i < parse_payload.data.length; i++) {
    const payload = {
      advertiser_id: context.getters.advertiser.id,
      counts: {
        id: parse_payload.data[i].id,
        timePeriod: parse_payload.time_period,
        total: parse_payload.data[i].counts.total,
        new: parse_payload.data[i].counts.new,
        returning: parse_payload.data[i].counts.returning,
      },
    }

    context.commit('addRewardCount', payload);
  }
}

const obtainImpressionCounts = async (context) => {
  await context.dispatch('inspectToken');

  if (context.getters.isLoggedIn) {
    const payload = {
      headers: {
        Authorization: `JWT ${context.rootState.jwt.jwt}`
      },
      params: {
        time_period: context.rootState.time_period,
        merchant_id: context.rootState.advertiser.advertiser.id,
      }
    }

    axios.get(context.state.endpoints.impressionCounts, payload)
      .then((response)=>{
        const parse_payload = {
          data: response.data,
          time_period: payload.params.time_period
        }
        context.dispatch('parseImpressionCounts', parse_payload);
      })
      .catch((error)=>{
        console.log(error);
      })
  }
}

const parseImpressionCounts = (context, parse_payload) => {
  const payload = {
    advertiser_id: context.getters.advertiser.id,
    counts: {
      id: parse_payload.data.id,
      timePeriod: parse_payload.time_period,
      profile_clicks: parse_payload.data.counts.profile_clicks,
      brand_impressions: parse_payload.data.counts.brand_impressions,
    },
  }

  context.commit('addImpressionCount', payload);
}

const obtainGraphCounts = async (context) => {
  await context.dispatch('inspectToken');

  if (context.getters.isLoggedIn) {
    const payload = {
      headers: {
        Authorization: `JWT ${context.rootState.jwt.jwt}`
      },
      params: {
        time_period: context.rootState.time_period,
        count_type: context.rootState.count_type,
        merchant_id: context.rootState.advertiser.advertiser.id,
      }
    }

    await axios.get(context.state.endpoints.graphCounts, payload)
      .then((response)=>{
        const parse_payload = {
          data: response.data,
          time_period: payload.params.time_period,
          count_type: payload.params.count_type,
        }

        context.dispatch('parseGraphCounts', parse_payload);
      })
      .catch((error)=>{
        console.log(error);
      })
  }
}

const parseGraphCounts = (context, parse_payload) => {
  context.commit('addGraphCounts', parse_payload)
}

export default {
  clearState,
  obtainRewardCounts,
  parseRewardCounts,
  obtainImpressionCounts,
  parseImpressionCounts,
  obtainGraphCounts,
  parseGraphCounts
}